import React, { useEffect, useState } from "react";
import OverlayContainer from "@components/Overlay/OverlayContainer";

import "./verificationEmail.scss";

import MailIcon from "../../assets/images/message.png";
import SendEmailAgain from "./SendEmailAgain";
import { Loading } from "@pages/Other/Loading";
import { useDispatch } from "react-redux";
import { errorActions } from "../../_actions";
import axiosInstance from "../../axios";

const VerificationEmail = ({
  setResendVerification,
  email,
  loginInfo,
  setLoginInfo,
}) => {
  const [time, setTime] = useState(0);
  const [isloading, setIsLoading] = useState(false);
  const [manageResendMail, setManageResendMail] = useState(false);
  const [loader, setLoader] = useState(false);

  const dispatch = useDispatch();

  const handleCloseVerification = () => {
    setResendVerification(false);
    dispatch(errorActions.hideError());
    setLoginInfo({ ...loginInfo, fetch: !loginInfo.fetch });
  };

  useEffect(() => {
    let interval = null;

    if (time > 0) {
      interval = setInterval(() => {
        setTime((prevTime) => prevTime - 1);
      }, 1000);
    }
    return () => {
      clearInterval(interval);
      setIsLoading(false);
    };
  }, [time]);

  const handleResendMail = async () => {
    setIsLoading(true);
    setLoader(true);

    try {
      const res = await axiosInstance.post("/get-verification-link", { email });

      if (!res?.data?.error) {
        setManageResendMail(true);
      }
    } catch (err) {
      console.error("Error resending verification mail:", err.message);
      // Optionally: show error feedback to user
    } finally {
      setIsLoading(false);
      setLoader(false);
    }
  };


  return (
    <>
      {manageResendMail === false && (
        <OverlayContainer>
          <div className="verify-email-dialog-inner">
            <div className="verify-email-heading">
              <div className="verify-email-title">
                <h2>Please verify your email address </h2>
              </div>
              <div
                className="verify-email-dialog-close"
                onClick={handleCloseVerification}
              >
                <div>
                  <i className="icon check"></i>
                </div>
              </div>
            </div>
            <div className="verify-email-mail-logo">
              <img src={MailIcon} alt="icon" />
            </div>
            <div className="verify-email-message-2">
              <p>
                For added security, we need to verify your email address. We’ve
                sent a verification link to <b>"{`${email}`}".</b> Please check
                your spam folder or have us send it again.
              </p>
            </div>
            <div className="verify-email-close-btn">
              <button onClick={handleResendMail}>
                SEND VERIFICATION EMAIL AGAIN
              </button>
            </div>
          </div>
        </OverlayContainer>
      )}

      {loader === true && (
        <OverlayContainer>
          <div className="signup-loading">
            <Loading />
          </div>
        </OverlayContainer>
      )}
      {loader === false && manageResendMail === true && (
        <SendEmailAgain
          isloading={isloading}
          setIsLoading={setIsLoading}
          handleCloseVerification={handleCloseVerification}
          email={email}
          setResendVerification={setResendVerification}
          time={time}
          setTime={setTime}
          handleResendMail={handleResendMail}
          loginInfo={loginInfo}
          setLoginInfo={setLoginInfo}
        />
      )}
    </>
  );
};

export default VerificationEmail;
